// extracted by mini-css-extract-plugin
export default {"overlay":"ModalNotificacion_overlay__UR7zC","modal":"ModalNotificacion_modal__bCm1S","success":"ModalNotificacion_success__IkLXt","error":"ModalNotificacion_error__6BF84"};